import React, { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { MaskLine } from "@/components/Reveal";
import { logosActifs, facteur, dureeBoucle } from "@/lib/bandeauLogos.mjs";

export function Cover({ couverture, logos }) {
  const reduced = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const yCenter = useTransform(scrollYProgress, [0, 1], [0, 120]);
  const hasVideo = Boolean(couverture?.videoPaysage);
  const marques = logosActifs({ logos });

  return (
    <section className="cover" ref={ref} data-testid="cover">
      <div className="cover-media">
        {hasVideo && !reduced ? (
          <video autoPlay muted loop playsInline preload="auto" poster={couverture.poster} data-testid="cover-video">
            {couverture.videoPortrait ? (
              <source src={couverture.videoPortrait} media="(orientation: portrait)" type="video/mp4" />
            ) : null}
            <source src={couverture.videoPaysage} type="video/mp4" />
          </video>
        ) : (
          <img src={couverture?.poster || "/posters/couverture.svg"} alt="Plateau de production SLIZ — ambiance de tournage sombre, logotype blanc au centre" fetchPriority="high" data-testid="cover-poster" />
        )}
      </div>
      <div className="cover-veil" aria-hidden="true" />

      <p className="cover-canaux" data-testid="cover-canaux">{couverture?.canaux || "SOCIAL · DOOH · TV"}</p>

      <motion.div className="cover-center" style={reduced ? {} : { y: yCenter }}>
        <h2 className="cover-logo" aria-hidden="true">
          <MaskLine delay={0.15}>SLIZ</MaskLine>
        </h2>
        <p className="cover-metiers" data-testid="cover-metiers">
          <MaskLine delay={0.35}>{couverture?.metiers || "Production & régie publicitaire"}</MaskLine>
        </p>
      </motion.div>

      <div className="cover-bottom">
        <h1 className="cover-h1" data-testid="cover-h1">
          <MaskLine delay={0.5}>
            {couverture?.h1a || "On produit"} <span className="dim">{couverture?.h1b || "et on diffuse vos films."}</span>
          </MaskLine>
        </h1>
        <div className="bandeau-logos" data-testid="bandeau-logos">
          <div className="bandeau-defile" style={{ "--duree": dureeBoucle(marques) }}>
            {[false, true].map((copie) => (
              <div className="bandeau-piste" key={String(copie)} aria-hidden={copie || undefined}>
                {marques.map((m) => (
                  <a
                    href="/realisations/"
                    className="bandeau-case"
                    key={`${m.nom}-${copie}`}
                    tabIndex={copie ? -1 : undefined}
                    data-testid={copie ? undefined : `bandeau-logo-${m.ordre}`}
                  >
                    {m.logo ? (
                      <img src={m.logo} alt={m.nom} loading="lazy" style={{ "--f": facteur(m) }} />
                    ) : (
                      <span className="bandeau-nom">{m.nom}</span>
                    )}
                  </a>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
